module.exports = __webpack_public_path__ + "static/media/montserrat-light-webfont.a11330db.eot";